import { call, put, select, takeLatest } from 'typed-redux-saga'
import { errorHandler, notifyMessageCreator } from 'Modules'
import { accessApi, accessSlice, accessNS, accessSelector } from 'Pages/knowledge'

export function* getArticlesAccessSaga(action: accessNS.getArticlesAccess) {
	try {
		if (action.payload) {
			const res = yield* call(accessApi.getArticlesAccess, action.payload)
			yield* put(accessSlice.actions.setArticlesAccess(res))
		}
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* createArticleAccessSaga(action: accessNS.createArticleAccess) {
	try {
		const { article_id } = action.payload.data
		const user_id = yield* select(accessSelector.getArticleAccessUserId)
		yield* call(accessApi.createAccess, { user_id, article_id })
		yield* put(accessSlice.actions.getArticlesAccess(user_id))
		yield* call(notifyMessageCreator, 'common.access.closed')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* deleteArticleAccessSaga(action: accessNS.deleteArticleAccess) {
	try {
		const userId = yield* select(accessSelector.getArticleAccessUserId)
		yield* call(accessApi.deleteAccess, action.payload.id)
		yield* put(accessSlice.actions.getArticlesAccess(userId))
		yield* call(notifyMessageCreator, 'common.access.open')
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* accessSaga() {
	yield* takeLatest(accessSlice.actions.getArticlesAccess.type, getArticlesAccessSaga)
	yield* takeLatest(accessSlice.actions.createArticleAccess.type, createArticleAccessSaga)
	yield* takeLatest(accessSlice.actions.deleteArticleAccess.type, deleteArticleAccessSaga)
}
